import { IFieldDisplayData } from "widgets/commonDataObjects/interfaces"
import { LinkTargetProperties } from "global/components/linkSettings/interfaces"

export interface MultiImagesMainAutoArticleItem {
    itemId: string
    title: string
    subTitle: string
    author: string
    titleLink: string
    titleTargetLink: LinkTargetProperties
    dateUpdatedOnSite: Date | string
    displayVideoIcon: boolean
    premiumExpireDays?: number
    categoryName: string
    imageUrl: string
    imageAlt: string
    imageTitle: string
}

export interface MultiImagesMainAutoFieldsProps {
    fieldsDisplaySettings: IFieldDisplayData
    titleColor: string
    subTitleColor: string
    labelColor: string
    labelBackgroundColor: string
}

export const MAIN_IMAGE_WIDTH = 718
export const MAIN_IMAGE_HEIGHT = 401
export const CAROUSEL_IMAGE_WIDTH = 220
export const CAROUSEL_IMAGE_HEIGHT = 124
export const CAROUSEL_ITEM_GAP = 20
